export const SEARCH = 'SEARCH'
